// @ts-nocheck
import {
  List,
  Datagrid,
  useListContext,
  FunctionField,
  TextField,
} from "react-admin";
import { format } from "date-fns";

const ListPage = (props) => {
  const listData = useListContext(props);

  return (
    <List {...props} title="Diasporas Holiday">
      <Datagrid
        data-test-id="datagrid_holiday"
        rowClick="edit"
        bulkActionButtons={false}
      >
        <TextField source="country_code" label="Country" />
        <FunctionField
          render={(record) => {
            return record?.content?.date;
          }}
          source="content"
          label="Title"
        />
        <FunctionField
          render={(record) => {
            return format(new Date(record?.updated_at), "dd-MM-yyyy");
          }}
          source="updated_at"
          label="Last Update"
        />
        {/* <RichTextField source="question" stripTags={true}/> */}
        {/* <RichTextField source="answer" stripTags={true} /> */}
        {/* <EditButton /> */}
      </Datagrid>
    </List>
  );
};

export default ListPage;
